let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6dT7c")).then(() => parcelRequire('jIPOV'));